module.exports = __webpack_public_path__ + "img/unitPriceEvaluation_fluctuation_04.fed508ff.png";